const L = {
  name: "SaoPaulo",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.1179 11L17.3415 2.55275L15.5526 1.65833L13.8818 5H10.1179L8.44706 1.65833L6.6582 2.55275L10.8818 11L7.38179 18H2V20H6.38179L5.6582 21.4472L7.44706 22.3416L8.61786 20H15.3818L16.5526 22.3416L18.3415 21.4472L17.6179 20H22V18H16.6179L13.1179 11ZM14.3818 18H9.61786L11.9998 13.236L14.3818 18ZM12.8818 7L11.9998 8.7639L11.1179 7H12.8818Z" fill="currentColor"/>
</svg>
  `
};
export {
  L as SaoPaulo
};
